import type { IUserConfig, IUserbase } from './types'
import { defHttp } from '@/utils/http'

/** 用户账户信息 余额/币种 */
export function fetchUserBase(): Promise<IUserbase> {
  return defHttp.post({
    url: '/v1/user/base',
  })
}

/** fetchPlayerStatistical */
export function fetchPlayerStatistical(data) {
  return defHttp.post({
    url: '/v1/user/transfer/playerStatistical',
    data,
  })
}

/** 获取App配置参数 */
export function fetchUserConfig(): Promise<IUserConfig> {
  return defHttp.post({
    url: '/v1/merchant/detail',
  })
}

export function fetchAccessCheck() {
  return defHttp.post({
    url: '/v1/user/accessCheck',
    data: {
      version: '1',
    },
  })
}
